<template>
  <div class="h-panel">
    <div :class="gridLayout" class="grid-container">
      <h-media-viewer :imagePadding="imagePadding" :editing="editing">
        <img
          :src="cloud(model.src)"
          :alt="model.alternateText"
          id="holos-media"
          @load="detectAspectRatio"
      /></h-media-viewer>
      <div class="info-panel" v-show="editing">
        <ValidationObserver ref="observer" v-slot="slots">
          <h-form ref="form" :model="model" :schema="schema" />
          <h-control-dock-edit v-bind="{ ...slots, ...subComponentProps }" />
        </ValidationObserver>
      </div>
      <div class="info-panel" v-show="!editing">
        <h-info-panel
          :model="model"
          :privateType="$attrs.privateType"
          :type="type"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { set, keys, clone } from "lodash";
import { ValidationObserver } from "vee-validate";
import * as ModalElements from "@/components/spaces/index.js";
import schema from "@/assets/schemas/fields/pictures.schema.js";
import { mixins } from "@/common/mixins.service";

export default {
  name: "CommonPicturesLayout",
  mixins: [mixins.pinterestLayout],
  components: { ValidationObserver, ...ModalElements.default },
  props: ["editing", "resource"],
  data() {
    return {
      model: undefined,
      schema: schema,
      type: `${this.$attrs.privateType ? "t_" : ""}pictures`,
    };
  },
  computed: {
    subComponentProps() {
      return {
        type: this.type,
        id: this.resource.id,
      };
    },
  },
  created() {
    this.setInfo(this.resource);
  },
  methods: {
    setInfo(info) {
      const init = clone(info);
      this.model = keys(this.schema).reduce((a, c) => set(a, c, init[c]), init);
    },
  },
  watch: {
    resource: {
      deep: true,
      handler(val) {
        this.setInfo(val);
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/bulma_overrides.scss";
@import "@/assets/scss/pinterestLayout.scss";
</style>
